import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["srcdoc", "title"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'

import { previewPage } from './embedPreviewPage'

const SOURCE = 'bottle-preview'
const CHAT_HEIGHT = 720
const FORM_MIN_HEIGHT = 160

export default {
  __name: 'EmbedPreview',
  props: {
  channel: { type: String, required: true },
  scriptUrl: { type: String, required: true },
  config: { type: Object, required: true },
  highlight: { type: String, default: null }
},
  emits: ['edit'],
  setup(__props, { expose: __expose, emit: __emit }) {

const LOADED_AT = Date.now()

const props = __props

const emit = __emit

const frame = ref(null)
const ready = ref(false)
const formHeight = ref(420)

const isChat = computed(() => props.channel === 'chat')
const page = computed(() => previewPage(props.channel, `${props.scriptUrl}?v=${LOADED_AT}`))
const title = computed(() => (isChat.value ? 'Chat widget preview' : 'Inquiry form preview'))
const height = computed(() => (isChat.value ? CHAT_HEIGHT : formHeight.value))

const send = message =>
  frame.value?.contentWindow?.postMessage({ ...JSON.parse(JSON.stringify(message)), source: SOURCE }, '*')

const onMessage = event => {
  if (!frame.value || event.source !== frame.value.contentWindow) return
  const data = event.data
  if (!data || data.source !== SOURCE) return

  if (data.type === 'ready') {
    ready.value = true
    send({ config: props.config, highlight: props.highlight })
  } else if (data.type === 'edit') {
    emit('edit', data.field, data.value)
  } else if (data.type === 'size' && !isChat.value) {
    formHeight.value = Math.max(Math.ceil(data.height), FORM_MIN_HEIGHT)
  }
}

watch(
  () => props.config,
  config => ready.value && send({ config }),
  { deep: true }
)
watch(
  () => props.highlight,
  highlight => ready.value && send({ highlight })
)
watch(page, () => (ready.value = false))

const restart = () => ready.value && send({ restart: true })

const focusText = field => {
  if (!ready.value) return
  frame.value?.focus()
  send({ focus: field })
}

__expose({ restart, focusText })

onMounted(() => window.addEventListener('message', onMessage))
onBeforeUnmount(() => window.removeEventListener('message', onMessage))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("iframe", {
    ref_key: "frame",
    ref: frame,
    srcdoc: page.value,
    title: title.value,
    sandbox: "allow-scripts allow-forms",
    class: "block w-full rounded-lg bg-white ring-1 ring-gray-200",
    style: _normalizeStyle({ height: `${height.value}px` })
  }, null, 12, _hoisted_1))
}
}

}